<template>
  <v-alert dismissible type="error" @input="onclose" v-model="showBrowserAlert">
    Para a utilização do portal, recomendamos o navegador em que o sistema foi
    homologado, o Google Chrome.
  </v-alert>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapMutations, mapState } = createNamespacedHelpers("portal");
var fechou_alerta = false;
export default {
  name: "BrowserAlert",
  computed: mapState(["showBrowserAlert"]),
  created() {
    this.browserVersionAlert();
  },
  methods: {
    ...mapMutations(["setShowBrowserAlert"]),
    onclose() {
      fechou_alerta = true;
    },
    browserVersionAlert() {
      let browser = (function() {
        var userAgent = navigator.userAgent;

        var match =
          userAgent.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];

        if (/trident/i.test(match[1])) {
          return "IE";
        }

        if (match[1] === "Chrome") {
          let browser = userAgent.match(/\b(OPR|Edge)\/(\d+)/);

          if (browser != null) {
            return browser[1].replace("OPR", "Opera");
          }
        }

        return match[1];
      })();
      if (fechou_alerta == false) {
        if (/iphone|ipod|ipad/i.test(navigator.userAgent)) {
          if (!/CriOS/i.test(navigator.userAgent)) {
            this.setShowBrowserAlert(true);
          }
        } else {
          if (browser !== "Chrome") {
            this.setShowBrowserAlert(true);
          }
        }
      } else {
        this.setShowBrowserAlert(false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-alert {
  margin: 0 !important;
}
</style>
